// extracted by mini-css-extract-plugin
export default {"arrow":"KMaGMA8LpAT2cqqNpSbe","accordion":"EDW84NDda1DYdvelNyYs","title":"k43W9fh5iDpG__BBvWFC","titleWrapper":"ovQpNOMu7AdJtRBDlu_C","accordionContent":"cXALQidsCHvbtDgHqgXH"};